import React from "react"
import { graphql } from "@apollo/client/react/hoc"
import { Label } from "reactstrap"
import Select from "react-select"
import toTitleCase from "../Functions/toTitleCase"
import { AllCarModelsQuery } from "./Modals/Queries"
import "./DesiredCarSpecsSelector.css"

const preferredCarGroups = [ "Intermediate Sedan", "Full Size Sedan", "Hybrid Sedan", "Compact SUV", "Intermediate SUV", "Full Size SUV"]

const DesiredCarTypeToggle = ({ type, compact, onTypeChange }) => (
    <div className={`preferred-car-editor__toggle${compact ? " preferred-car-editor__toggle--compact" : ""}`} role="tablist" aria-label="Desired car specification type">
        <button type="button" role="tab" className={type === "model" ? "active" : ""} aria-selected={type === "model"} onClick={() => onTypeChange("model")}>
            <i className="fa fa-car" aria-hidden="true" />{compact ? "Model" : "Car Model"}
        </button>
        <button type="button" role="tab" className={type === "group" ? "active" : ""} aria-selected={type === "group"} onClick={() => onTypeChange("group")}>
            <i className="fa fa-cubes" aria-hidden="true" />
            {compact ? "Group" : "Car Group"}
        </button>
    </div>
)

const DesiredCarSpecsSelector = ({ type, value, allCarModels, allCarModelsLoading, isClearable, compact, title, onTypeChange, onChange }) => (
    <>
        {compact ?
            <div className="desired-car-specs-selector__header">
                <Label>{title}</Label>
                <DesiredCarTypeToggle type={type} compact onTypeChange={onTypeChange} />
            </div> :
            <>
                <DesiredCarTypeToggle type={type} onTypeChange={onTypeChange} />
                <Label className="mt-2" for={type === "model" ? "preferredCarModel" : "preferredCarGroup"}>
                    Select Car {type === "model" ? "Model" : "Group"}
                </Label>
            </>
        }
        <Select
            key={type}
            inputId={type === "model" ? "preferredCarModel" : "preferredCarGroup"}
            className="bos-custom-select"
            classNamePrefix="bos-select"
            value={value ? { value, label: value } : null}
            options={type === "model" ? allCarModels?.edges?.map(carModel => ({ value: toTitleCase(carModel.node.name), label: toTitleCase(carModel.node.name) })) : preferredCarGroups.map(carGroup => ({ value: carGroup, label: carGroup }))}
            isLoading={type === "model" && allCarModelsLoading}
            isClearable={isClearable}
            placeholder={type === "model" ? "e.g. Camry" : "e.g. Intermediate Sedan"}
            onChange={(selectedOption) => onChange(selectedOption ? selectedOption.value : "")}
        />
    </>
)

export default graphql(AllCarModelsQuery, {
    options: () => ({
        variables: {
            carStages: [8, 9, 10, 11],
            hasReturnDate: true,
            hasReservation: false,
            orderBy: ["-make"],
        },
    }),
    props: ({ data: { loading, allCarModels } }) => ({
        allCarModelsLoading: loading,
        allCarModels,
    }),
})(DesiredCarSpecsSelector)
